export default "__VITE_ASSET__BHvUQDd0__"